import SearchPage from './SearchPage';

export default function HomePage() {
    return <SearchPage />;
}

